// src/components/operationsAssociate/AssetsTabs.jsx
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const AssetsTabs = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const tabs = [
        { label: "Asset Registry", path: "/assets-management" },
        { label: "Return Hub", path: "/assets-return" },
        { label: "My Resources", path: "/my-resources" },
    ];

    return (
        <div className="flex items-center gap-1 p-1 bg-gray-100/50 rounded-2xl overflow-hidden relative">
            {tabs.map((tab) => {
                const isActive = location.pathname === tab.path;
                return (
                    <button
                        key={tab.path}
                        onClick={() => navigate(tab.path)}
                        className={`relative px-6 py-2.5 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all duration-300 z-10
                            ${isActive ? "text-white" : "text-gray-500 hover:text-gray-800"}
                        `}
                    >
                        {isActive && (
                            <motion.div
                                layoutId="activeTabAssets"
                                className="absolute inset-0 bg-gray-900 rounded-xl shadow-lg -z-10"
                                transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
                            />
                        )}
                        {tab.label}
                    </button>
                );
            })}
        </div>
    );
};

export default AssetsTabs;
